import _typeof from "@babel/runtime/helpers/typeof";
var extractDataFromStringAttribute = function extractDataFromStringAttribute(string) {
  var arr = string.split(' ');
  switch (arr.length) {
    case 1:
      return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: arr[0],
        attributes: undefined
      };
    case 2:
      return {
        actionSubject: arr[0],
        action: arr[1],
        actionSubjectId: undefined,
        attributes: undefined
      };
    default:
      throw Error('Event of this type is not supported');
  }
};
var extractDataFromOneAttribute = function extractDataFromOneAttribute(one) {
  if (typeof one === 'string') {
    return extractDataFromStringAttribute(one);
  }
  if (_typeof(one) === 'object') {
    return {
      actionSubject: undefined,
      action: undefined,
      actionSubjectId: undefined,
      attributes: one
    };
  }
  throw Error('Event of this type is not supported');
};
var extractDataFromTwoAttribute = function extractDataFromTwoAttribute(one, two) {
  if (typeof one === 'string' && typeof two === 'string') {
    var _extractDataFromStrin = extractDataFromStringAttribute(one),
      action = _extractDataFromStrin.action,
      actionSubject = _extractDataFromStrin.actionSubject;
    var actionSubjectId = two;
    return {
      actionSubject: actionSubject,
      action: action,
      actionSubjectId: actionSubjectId,
      attributes: undefined
    };
  }
  if (typeof one === 'string' && _typeof(two) === 'object') {
    var _extractDataFromStrin2 = extractDataFromStringAttribute(one),
      _action = _extractDataFromStrin2.action,
      _actionSubject = _extractDataFromStrin2.actionSubject,
      _actionSubjectId = _extractDataFromStrin2.actionSubjectId;
    return {
      actionSubject: _actionSubject,
      action: _action,
      actionSubjectId: _actionSubjectId,
      attributes: two
    };
  }
  throw Error('Event of this type is not supported');
};
var extractDataFromThreeAttribute = function extractDataFromThreeAttribute(one, two, three) {
  if (typeof one === 'string' && typeof two === 'string' && _typeof(three) === 'object') {
    var _extractDataFromStrin3 = extractDataFromStringAttribute(one),
      action = _extractDataFromStrin3.action,
      actionSubject = _extractDataFromStrin3.actionSubject;
    var actionSubjectId = two;
    return {
      actionSubject: actionSubject,
      action: action,
      actionSubjectId: actionSubjectId,
      attributes: three
    };
  }
  throw Error('Event of this type is not supported');
};
export var getImperativeAnalyticsDataFromArguments = function getImperativeAnalyticsDataFromArguments(args) {
  switch (args.length) {
    case 0:
      return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: undefined
      };
    case 1:
      return extractDataFromOneAttribute(args[0]);
    case 2:
      return extractDataFromTwoAttribute(args[0], args[1]);
    case 3:
      return extractDataFromThreeAttribute(args[0], args[1], args[2]);
    default:
      throw Error('Can not fire an empty event');
  }
};